(function () {
  var ready = function (fn) {
    if (document.readyState !== "loading") {
      fn();
      return;
    }
    document.addEventListener("DOMContentLoaded", fn);
  };

  var getJSON = function (value, fallback) {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  };

  var setReadArticles = function (handles) {
    localStorage.setItem("matf_read_articles", JSON.stringify(handles));
  };

  var recordReadArticle = function () {
    var articleRoot = document.querySelector("[data-article-handle]");
    var newsletter = document.querySelector("[data-newsletter-gated]");
    if (!articleRoot || !newsletter) return;

    var isRecipe = articleRoot.getAttribute("data-article-is-recipe") === "true";
    var countAll = newsletter.getAttribute("data-count-all") === "true";
    if (!isRecipe && !countAll) return;

    var handle = articleRoot.getAttribute("data-article-handle");
    if (!handle) return;

    var existing = getJSON(localStorage.getItem("matf_read_articles"), []);
    if (existing.indexOf(handle) === -1) {
      existing.push(handle);
      setReadArticles(existing);
    }
  };

  var canShowNewsletter = function (newsletter) {
    var subscribed = localStorage.getItem("matf_newsletter_subscribed") === "true";
    if (subscribed) return false;
    var dismissed = getJSON(localStorage.getItem("matf_newsletter_dismissed"), null);
    if (dismissed && dismissed.t) {
      var ttlDays = 14;
      if (!isNaN(ttlDays) && ttlDays > 0) {
        var expiresAt = dismissed.t + ttlDays * 86400000;
        if (Date.now() > expiresAt) {
          localStorage.removeItem("matf_newsletter_dismissed");
          dismissed = null;
        }
      }
    }
    if (dismissed) return false;

    var isMobile = window.matchMedia("(max-width: 749px)").matches;
    var threshold = parseInt(newsletter.getAttribute("data-threshold"), 10) || 0;
    if (isMobile) threshold = 0;
    if (!isMobile && threshold > 1) threshold = 1;
    var readCount = getJSON(localStorage.getItem("matf_read_articles"), []).length;
    return readCount >= threshold;
  };

  var setupNewsletter = function () {
    var newsletter = document.querySelector("[data-newsletter-gated]");
    if (!newsletter) return;

    recordReadArticle();

    var revealOnScroll = newsletter.getAttribute("data-reveal-scroll") === "true";
    var scrollPercent = parseInt(newsletter.getAttribute("data-scroll-percent"), 10) || 40;
    var isMobile = window.matchMedia("(max-width: 749px)").matches;
    if (!isMobile) revealOnScroll = false;

    var reveal = function () {
      if (!canShowNewsletter(newsletter)) return;
      newsletter.setAttribute("data-visible", "true");
    };

    if (!revealOnScroll) {
      reveal();
      return;
    }

    var scrollDownCount = 0;
    var lastScrollY = window.scrollY || window.pageYOffset;
    var lastTriggerY = lastScrollY;
    var minScrollDelta = isMobile ? 140 : 120;
    var requiredScrollCount = isMobile ? 3 : 2;
    var onScroll = function () {
      var scrollTop = window.scrollY || window.pageYOffset;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) {
        reveal();
        window.removeEventListener("scroll", onScroll);
        return;
      }
      if (scrollTop > lastTriggerY + minScrollDelta) {
        scrollDownCount += 1;
        lastTriggerY = scrollTop;
      }
      lastScrollY = scrollTop;
      var percent = Math.round((scrollTop / docHeight) * 100);
      var shouldReveal = isMobile
        ? scrollDownCount >= requiredScrollCount
        : scrollDownCount >= requiredScrollCount || percent >= scrollPercent;
      if (shouldReveal) {
        reveal();
        window.removeEventListener("scroll", onScroll);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
  };

  var setupNewsletterDismiss = function () {
    var dismissBtn = document.querySelector("[data-newsletter-dismiss]");
    var newsletter = document.querySelector("[data-newsletter-gated]");
    if (!dismissBtn || !newsletter) return;

    dismissBtn.addEventListener("click", function () {
      newsletter.setAttribute("data-visible", "false");
      localStorage.setItem(
        "matf_newsletter_dismissed",
        JSON.stringify({ t: Date.now() })
      );
    });
  };

  var setupFacebookShareDeepLink = function () {
    var links = document.querySelectorAll("[data-facebook-share]");
    if (!links.length) return;
    var isMobile = window.matchMedia("(max-width: 749px)").matches;
    if (!isMobile) return;

    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault();
        var rawShareUrl = link.getAttribute("data-share-url");
        var shareUrl = rawShareUrl || window.location.href;
        if (navigator.share) {
          var sharePromise = navigator.share({
            title: document.title,
            url: shareUrl,
          });
          if (sharePromise && sharePromise.catch) {
            sharePromise.catch(function () {});
          }
          return;
        }
        window.open(
          "https://www.facebook.com/sharer/sharer.php?u=" +
            encodeURIComponent(shareUrl),
          "_blank",
          "noopener"
        );
      });
    });
  };

  var setupNewsletterSubmit = function () {
    var newsletter = document.querySelector("[data-newsletter-gated]");
    var forms = document.querySelectorAll(".newsletter-gated__form");
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener("submit", function () {
        localStorage.setItem("matf_newsletter_subscribed", "true");
        if (newsletter) newsletter.setAttribute("data-visible", "false");
        localStorage.removeItem("matf_newsletter_dismissed");
      });
    });
  };


  var hashCode = function (input) {
    var hash = 0;
    for (var i = 0; i < input.length; i++) {
      hash = (hash << 5) - hash + input.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  };

  var selectPromoIndex = function (slot, count) {
    var mode = slot.getAttribute("data-rotation") || "static_first";
    if (count <= 1) return 0;

    if (mode === "rotate_daily") {
      var today = new Date();
      var key =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        "-" +
        slot.getAttribute("data-slot-id");
      return hashCode(key) % count;
    }

    if (mode === "rotate_per_session") {
      var storageKey = "matf_promo_slot_" + slot.getAttribute("data-slot-id");
      var stored = sessionStorage.getItem(storageKey);
      if (stored !== null) return parseInt(stored, 10) || 0;
      var randomIndex = Math.floor(Math.random() * count);
      sessionStorage.setItem(storageKey, String(randomIndex));
      return randomIndex;
    }

    return 0;
  };

  var setupPromoSlots = function () {
    var slots = document.querySelectorAll("[data-promo-slot]");
    if (!slots.length) return;

    slots.forEach(function (slot) {
      var items = slot.querySelectorAll("[data-promo-item]");
      if (!items.length) return;
      var activeIndex = selectPromoIndex(slot, items.length);
      items.forEach(function (item, index) {
        item.setAttribute("data-active", index === activeIndex ? "true" : "false");
      });
    });
  };

  ready(function () {
    setupNewsletter();
    setupNewsletterDismiss();
    setupPromoSlots();
    if (!window.__matfPrintHandlersBound) {
      window.__matfPrintHandlersBound = true;
      var printState = window.__matfPrintState || {
        isPrinting: false,
        printCooldownUntil: 0,
        printResetTimeout: null,
      };
      window.__matfPrintState = printState;
      var startPrintState = function () {
        printState.isPrinting = true;
        printState.printCooldownUntil = Date.now() + 1000;
        document.documentElement.setAttribute("data-printing", "true");
        if (printState.printResetTimeout)
          window.clearTimeout(printState.printResetTimeout);
        printState.printResetTimeout = window.setTimeout(function () {
          if (!printState.isPrinting) return;
          printState.isPrinting = false;
          document.documentElement.removeAttribute("data-printing");
        }, 4000);
      };
      var finishPrintState = function () {
        printState.printCooldownUntil = Date.now() + 1000;
        if (printState.printResetTimeout) {
          window.clearTimeout(printState.printResetTimeout);
          printState.printResetTimeout = null;
        }
        window.setTimeout(function () {
          printState.isPrinting = false;
          document.documentElement.removeAttribute("data-printing");
        }, 200);
      };
      window.addEventListener("beforeprint", function () {
        if (!printState.isPrinting) startPrintState();
      });
      window.addEventListener("afterprint", function () {
        finishPrintState();
      });
      document.addEventListener("click", function (event) {
        var target = event.target;
        var trigger = target ? target.closest("[data-print-page]") : null;
        if (trigger) {
          event.preventDefault();
          if (
            printState.isPrinting ||
            Date.now() < printState.printCooldownUntil
          )
            return;
          startPrintState();
          try {
            window.print();
          } catch (e) {
            finishPrintState();
          }
        }
      });
    }
    setupNewsletterSubmit();
    setupFacebookShareDeepLink();
  });
})();
